import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import {Col, Row} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import {BusinessDataUsageMain} from 'app/Components/Block/BusinessDataUsageBlock/BusinessDataUsageMain';
import Main from 'app/Components/Block/CreditGuardBlock/main';

export const AbroadContactUsMain = ({iContent}) => {
  const {deskSettings, mobSettings, settings: generalSettings} = iContent;

  const {
    primaryTextColor: {value: primaryTextColor = null} = {},
    secondaryTextColor: {value: secondaryTextColor = null} = {},
    mainTitle: {value: mainTitle = null} = {},
    secondaryTitle: {value: secondaryTitle = null} = {},
    phoneTitle: {value: phoneTitle = null} = {},
    phoneNum: {value: phoneNum = null} = {},
    whatsAppTitle: {value: whatsAppTitle = null} = {},
    whatsAppNum: {value: whatsAppNum = null} = {}
  } = generalSettings;

  const whatsAppIcon = generalSettings?.whatsAppIcon?.value?.url
    ? Config.epiBaseUrl + generalSettings?.whatsAppIcon?.value?.url
    : null;
  const phoneIcon = generalSettings?.phoneIcon?.value?.url
    ? Config.epiBaseUrl + generalSettings?.phoneIcon?.value?.url
    : null;
  const mobImage = mobSettings?.mobImage?.value?.url
    ? Config.epiBaseUrl + mobSettings?.mobImage?.value?.url
    : null;

  const alignmentStyle = {
    justifyContent: deskSettings?.elementAlignment?.value
  };
  const deskImage = deskSettings?.deskImage?.value?.url
    ? Config.epiBaseUrl + deskSettings?.deskImage?.value?.url
    : null;

  const image = isMobile && mobImage ? mobImage : deskImage;


  const mainStyle = {
    color: primaryTextColor
  };
  const secondaryStyle = {
    color: secondaryTextColor
  };

  const formatWhatsAppNum = (phoneNumber) => {
    const symbols = ['+', '-', '(', ')', ' '];
    let formattedNumber = '';

    for (let i = 0; i < phoneNumber.length; i++) {
      const char = phoneNumber[i];
      if (!symbols.includes(char)) {
        formattedNumber += char;
      }
    }

    return formattedNumber;
  };

  const formattedPhoneNum = phoneNum && isMobile ? `tel:${phoneNum}` : null;
  const formattedWhatsAppNum = whatsAppNum && isMobile ? `https://wa.me/${formatWhatsAppNum(whatsAppNum)}` : null;


  return (
    <div style={alignmentStyle} className='main-container'>
      {image && <Image className={'image'} src={image} alt={'Main Image'} />
      }      <div className='text-container'>
        <div className='titles'>
          {mainTitle && <div style={mainStyle} dangerouslySetInnerHTML={{__html: mainTitle}} />}
          {secondaryTitle && <div style={mainStyle} dangerouslySetInnerHTML={{__html: secondaryTitle}} />}
        </div>
        <div className='contact-row'>
          <div className='contact-title'>
            {whatsAppIcon && <Image src={whatsAppIcon} alt='WhatsApp' />}
            {whatsAppTitle && <p style={mainStyle}>{whatsAppTitle}</p>}
          </div>
          {whatsAppNum && (
            <a style={secondaryStyle} className='number' href={formattedWhatsAppNum} target='_blank'>
              {whatsAppNum}
            </a>
          )}
        </div>
        <div className='contact-row'>
          <div className='contact-title'>
            {phoneIcon && <Image src={phoneIcon} alt='Phone' />}
            {phoneTitle && <p style={mainStyle}>{phoneTitle}</p>}
          </div>
          {phoneNum && (
            <a style={secondaryStyle} className='number' href={formattedPhoneNum}>
              {phoneNum}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  // mapStateToProps implementation if needed
});

export default connect(mapStateToProps)(AbroadContactUsMain);
0;